import { SAVE_VERSION, type SaveDoc } from './save.js';

/**
 * Каждая версия схемы получает функцию перехода с предыдущей.
 * Первое же изменение баланса ломает сейвы тестеров, если этого нет.
 */
type Migration = (doc: Record<string, unknown>) => Record<string, unknown>;

const migrations: Record<number, Migration> = {
  // M1: у мира появилось состояние — что игрок успел тронуть за день.
  2: (doc) => ({ ...doc, world: { touched: [] } }),
  // M2: завелись хабар и точки дохода.
  3: (doc) => ({ ...doc, habar: [], businesses: [] }),
  // M3: спутницы приехали раньше срока — стресс было нечем снимать.
  4: (doc) => ({ ...doc, companions: [] }),
  // M5: следствие, суд и итог прохождения.
  9: (doc) => ({ ...doc, justice: { raids: 0, lastRaidDay: 0, courtDay: null }, outcome: 'active' }),
  // M4: бригада, территории и палево от производства.
  8: (doc) => ({
    ...doc,
    brigade: [],
    territories: [],
    businesses: ((doc['businesses'] as { heatPerNight?: number }[]) ?? []).map((business) => ({
      ...business,
      heatPerNight: business.heatPerNight ?? 0,
    })),
  }),
  // M3: люди района, квесты и счётчики.
  7: (doc) => ({ ...doc, npc: {}, quests: {}, counters: {} }),
  // M4: тачки — дорога, вместимость и приметность.
  6: (doc) => ({ ...doc, garage: [], activeVehicle: null }),
  // M4: прокачка и шмот.
  5: (doc) => ({
    ...doc,
    owned: [],
    equipment: {},
    player: { ...(doc['player'] as object), statPoints: 0, classId: null, subclassId: null },
  }),
};

export class SaveTooNewError extends Error {
  constructor(version: number) {
    super(`Сейв версии ${version} новее игры (${SAVE_VERSION}). Обнови страницу.`);
    this.name = 'SaveTooNewError';
  }
}

export function migrate(raw: unknown): SaveDoc {
  if (typeof raw !== 'object' || raw === null) throw new Error('Сейв повреждён: это не объект.');
  let doc = raw as Record<string, unknown>;
  const version = typeof doc['version'] === 'number' ? doc['version'] : 0;

  if (version > SAVE_VERSION) throw new SaveTooNewError(version);

  for (let v = version + 1; v <= SAVE_VERSION; v++) {
    const step = migrations[v];
    if (step) doc = step(doc);
    doc['version'] = v;
  }

  return doc as unknown as SaveDoc;
}
